import { useState } from 'react'
import HistoryItem from './history-item'
import BouncingDots from '../../components/BouncingDots'

const History = ({ history = [], providers = [], isApiCalling }) => {
  const [openIdx, setOpenIdx] = useState(null)

  const reversed = [...history].reverse()
  return (
    <div className='basis-3/5'>
      <h3 data-tour='api-history-header'>Request History</h3>
      {isApiCalling && (
        <BouncingDots message='Waiting for API response...' />
      )}
      {reversed.map((h, idx) => <HistoryItem key={idx} data={h} setOpen={() => setOpenIdx(openIdx === idx ? null : idx)} isOpen={idx === openIdx} providers={providers} />)}
    </div>
  )
}

export default History
